"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const taskCreated_graphql_1 = tslib_1.__importDefault(require("../../../gql/tasks/subscriptions/taskCreated.graphql"));
function taskCreatedHandler() {
    return {
        document: taskCreated_graphql_1.default,
        updateQuery: (previous, { subscriptionData }) => {
            const { fetchTasks } = previous;
            const { taskCreated } = subscriptionData.data;
            return {
                fetchTasks: [
                    taskCreated,
                    ...fetchTasks,
                ],
            };
        },
        onError: (error) => {
            console.log(error);
        },
    };
}
exports.default = taskCreatedHandler;
//# sourceMappingURL=taskCreated.js.map